import { FC } from 'react';

import { CountryCode } from '../../enums/CountryCode';
import { getCountryCode } from '../../utils/localization';

interface IFullNameProps {
  firstName: string;
  middleName?: string | null;
  lastName: string;
}

const FullName: FC<IFullNameProps> = ({ firstName, middleName = '', lastName }) => {
  return getCountryCode() === CountryCode.Japan ? (
    <>
      {lastName} {firstName} {middleName}
    </>
  ) : (
    <>
      {firstName} {middleName && `${middleName} `}
      {lastName}
    </>
  );
};

export default FullName;
